(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.classList.add('hide');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.classList.toggle('hide');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // 控制热门搜索词的显示/隐藏
  (function() {
    const searchInput = document.getElementById('Search-In-Modal-1');
    const trendingSearches = document.querySelector('.trending-searches');
    
    if (!searchInput || !trendingSearches) return;
    
    function showTrendingSearches() {
      trendingSearches.classList.remove('trending-searches--hidden');
    }
    
    function hideTrendingSearches() {
      trendingSearches.classList.add('trending-searches--hidden');
    }
    
    // 点击搜索框时显示
    searchInput.addEventListener('click', function(e) {
      e.stopPropagation();
      showTrendingSearches();
    });
    
    // 聚焦搜索框时显示
    searchInput.addEventListener('focus', function(e) {
      showTrendingSearches();
    });
    
    // 点击页面其他地方时隐藏
    document.addEventListener('click', function(e) {
      const searchForm = searchInput.closest('.search-header');
      if (searchForm && !searchForm.contains(e.target)) {
        hideTrendingSearches();
      }
    });
    
    // 失去焦点时隐藏（延迟一点，避免点击热门搜索词时立即隐藏）
    searchInput.addEventListener('blur', function(e) {
      setTimeout(function() {
        if (document.activeElement !== searchInput && !trendingSearches.contains(document.activeElement)) {
          hideTrendingSearches();
        }
      }, 200);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-crowdfunding"]) return;
  try {
    
    class ProductModal extends ModalDialog {
        constructor() {
            super();
        }
        hide() {
            super.hide();
        }
        show(opener) {
            super.show(opener);
            this.showActiveMedia();
        }
        showActiveMedia() {
            this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                element.classList.remove('active');
            })
            const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            const container = this.querySelector('[role="document"]');
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
            if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                activeMedia.loadContent();
            }
        }
    customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
        constructor() {
            super();
        }
        hide() {
            super.hide();
        }
        show(opener) {
            super.show(opener);
            this.showActiveMedia();
        }
        showActiveMedia() {
            this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                element.classList.remove('active');
            })
            const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            const container = this.querySelector('[role="document"]');
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
            if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                activeMedia.loadContent();
            }
        }
    customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
